import { useState, useEffect } from 'react';
import Axios from '../utils/axiosInstance';

const useSocialHandles = () => {
  const [socialHandles, setSocialHandles] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSocialHandles = async () => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}reviews/social-accounts`);
        setSocialHandles(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSocialHandles();
  }, []);

  return { socialHandles};
};

export default useSocialHandles;
